// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Client/style/core.scss
// module id = 482
// module chunks = 0 2